/* Futurizta need-based menu (2026-10-15). Desktop: hover or click opens a panel under the header.
   Mobile drawer: one accordion row per tab. */
(function () {
  var nav = document.querySelector('[data-ftz-nav]');
  var open = null;
  var timer = null;
  var canHover = window.matchMedia('(hover: hover)').matches;
  var scrim = null;

  function place(panel) {
    var header = document.querySelector('.site-header') || nav;
    var top = Math.round(header.getBoundingClientRect().bottom) + 'px';
    panel.style.top = top;
    if (scrim) scrim.style.top = top;
  }
  function show(item) {
    if (open === item) return;
    var swap = !!open;
    hide(swap);
    var btn = item.querySelector('.ftz-nav__top');
    var panel = item.querySelector('.ftz-nav__panel');
    panel.classList.toggle('is-swap', swap);
    place(panel);
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
    open = item;
  }
  function hide(keepScrim) {
    if (!open) return;
    open.querySelector('.ftz-nav__panel').hidden = true;
    open.querySelector('.ftz-nav__top').setAttribute('aria-expanded', 'false');
    open.classList.remove('is-open');
    if (scrim && !keepScrim) scrim.classList.remove('is-on');
    open = null;
  }
  // Hovering a "Which one is for you?" answer lights up its product card.
  function light(row, on) {
    var panel = row.closest('.ftz-nav__body');
    var path = row.pathname;
    panel.querySelectorAll('.ftz-card').forEach(function (c) {
      c.classList.toggle('is-lit', on && c.pathname === path);
    });
  }

  // Panels are display:none, so their lazy images only start loading when a panel opens (blank flash).
  // Warm them once the shopper reaches the header or the drawer instead of on every page load.
  var warmed = false;
  function warm(e) {
    if (warmed || !e.target.closest || !e.target.closest('.site-header, [data-ftz-nav], .mobile-nav, .drawer')) return;
    warmed = true;
    document.querySelectorAll('.ftz-nav__body img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    ['pointerover', 'touchstart', 'focusin'].forEach(function (t) { document.removeEventListener(t, warm, true); });
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (t) { document.addEventListener(t, warm, { capture: true, passive: true }); });

  if (nav) {
    scrim = document.createElement('div');
    scrim.className = 'ftz-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    nav.appendChild(scrim);
    nav.querySelectorAll('.ftz-panel__choose > a').forEach(function (row) {
      row.addEventListener('mouseenter', function () { light(row, true); });
      row.addEventListener('mouseleave', function () { light(row, false); });
    });
    nav.querySelectorAll('[data-ftz-item]').forEach(function (item) {
      var btn = item.querySelector('.ftz-nav__top');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (open === item) hide(); else show(item);
      });
      if (canHover) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { show(item); }, open ? 0 : 120);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(timer);
          timer = setTimeout(hide, 220);
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) {
        var btn = open.querySelector('.ftz-nav__top');
        hide();
        btn.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (open && !open.contains(e.target)) hide();
    });
    window.addEventListener('scroll', function () {
      if (open) place(open.querySelector('.ftz-nav__panel'));
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ftz-m]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var expand = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
    panel.hidden = !expand;
  });
})();

/* Menu click tracking (2026-10-21, Growth Director change #18). A click on a link inside a menu panel
   (desktop ftz-p-<tab>, mobile drawer ftz-m-<tab>):
   - GA4 G-D4F8GYTJ1J event menu_click_<tab> {menu_path, menu_device}. Sent at once when gtag is loaded,
     else queued in sessionStorage and sent on the next page (the theme loads gtag lazily).
   - localStorage ftz_menu keeps "<tab>|<path>" for 7 days and writes it to cart attribute _menu, so orders
     carry it in note_attributes. Re-checked on load, 5 s after load, 1.2 s after Add to cart and by beacon on
     checkout click (Kaching's cart writes can drop it, same pattern as ftz-hydra-ab).
   - GA4 skipped when Shopify customerPrivacy says analytics is not allowed. */
(function () {
  if (window.ftzMenuTrack) return;
  window.ftzMenuTrack = true;
  var MID = 'G-D4F8GYTJ1J', KEY = 'ftz_menu', QKEY = 'ftz_menu_q', TTL = 7 * 864e5;
  var log = window.ftzMenuLog = [];
  function allowed() {
    try {
      var p = window.Shopify && Shopify.customerPrivacy;
      return !(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed() === false);
    } catch (e) { return true; }
  }
  function store(s, k, v) {
    try {
      if (v === undefined) return s.getItem(k);
      if (v === null) s.removeItem(k); else s.setItem(k, v);
    } catch (e) { return null; }
  }
  function ready() {
    return typeof window.gtag === 'function' && document.querySelector('script[src*="gtag/js?id=' + MID + '"]');
  }
  function g() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  function send(ev) {
    g('event', ev.n, { send_to: MID, menu_path: ev.p, menu_device: ev.d, transport_type: 'beacon' });
    log.push(ev.n);
  }
  function queued() {
    try { return JSON.parse(store(sessionStorage, QKEY) || '[]'); } catch (e) { return []; }
  }
  function flush() {
    var q = queued();
    if (!q.length || !allowed()) return;
    if (!ready()) {
      g('js', new Date());
      g('config', MID, { send_page_view: false });
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MID;
      document.head.appendChild(s);
    }
    store(sessionStorage, QKEY, null);
    q.forEach(send);
  }

  function current() {
    try {
      var c = JSON.parse(store(localStorage, KEY) || 'null');
      return c && Date.now() - c.t < TTL ? c.v : null;
    } catch (e) { return null; }
  }
  var F = window.fetch, busy = 0;
  function ensureTag() {
    var v = current();
    if (!v || busy || !F) return;
    busy = 1;
    F.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.attributes && c.attributes._menu === v) return;
      return F.call(window, '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _menu: v } })
      }).then(function (r) { if (r.ok) log.push('tag_written'); });
    }).catch(function () {}).then(function () { busy = 0; });
  }
  function beaconTag() {
    var v = current();
    try { if (v && navigator.sendBeacon) navigator.sendBeacon('/cart/update.js', new URLSearchParams({ 'attributes[_menu]': v })); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[name="checkout"],a[href*="/checkout"],button[onclick*="checkout"]')) { beaconTag(); return; }
    var a = t.closest('a[href]'), body = a && a.closest('.ftz-nav__body');
    if (!body) return;
    var m = /^ftz-([pm])-([a-z]+)$/.exec(body.id || '');
    if (!m) return;
    var path = (a.pathname || '/').slice(0, 90);
    store(localStorage, KEY, JSON.stringify({ v: m[2] + '|' + path, t: Date.now() }));
    if (!allowed()) return;
    var ev = { n: 'menu_click_' + m[2], p: path, d: m[1] === 'p' ? 'desktop' : 'mobile' };
    if (ready()) send(ev);
    else { var q = queued(); q.push(ev); store(sessionStorage, QKEY, JSON.stringify(q.slice(-5))); }
  }, true);

  var atcAt = 0;
  function atc() {
    var n = Date.now();
    if (n - atcAt < 1500) return;
    atcAt = n;
    setTimeout(ensureTag, 1200);
  }
  if (F) {
    window.fetch = function (i) {
      var p = F.apply(this, arguments);
      try {
        var u = typeof i === 'string' ? i : (i && i.url) || '';
        if (/\/cart\/add/.test(u)) p.then(function (r) { if (r && r.ok) atc(); }).catch(function () {});
      } catch (e) {}
      return p;
    };
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) atc();
  }, true);

  function onLoad() { ensureTag(); setTimeout(ensureTag, 5000); setTimeout(flush, 3000); }
  if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
})();
